import MapDisplayModes from 'aria-viewer/map/MapDisplayModes'
import { showSupplementalMediaPreview } from 'aria-viewer/players/supplementalmedia/supplementalMediaActions'
import { setElapsedTime } from 'aria-viewer/analytics/analyticActions'
import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import injectJss from 'react-jss'
import compose from 'recompose/compose'
import MainMediaManager from 'aria-viewer/media/components/mainMediaManager'
import { LoadingScreen } from 'aria-viewer/loadingscreen'
import Navigation from 'aria-viewer/navigation/navigation'
import Drawer from 'aria-viewer/drawer/drawer'
import ToursList from './toursList'
import TourButtons, { TOP_RIGHT, RIGHT_TOP, BOTTOM_RIGHT, BOTTOM_LEFT } from './tourButtons'
import { connect } from 'react-redux'
import mapSelectorsToProps from 'aria-viewer/core/selectors/mapSelectorsToProps'
import OpacityHelper from 'aria-viewer/tour/components/opacityHelper'
import LocationTitleButton from 'aria-viewer/tour/components/buttons/LocationTitleButton'
import ContextMenuIndex from 'aria-viewer/contextmenu/'
import ContextMenuManager from 'aria-viewer/contextmenu/components/ContextMenuManager'
import RegistrationWrapper from 'aria-viewer/registration/registrationWrapper'

import StopsList from 'aria-viewer/stopselector/containers/StopsList'
import Avatar from 'aria-viewer/guide/components/Avatar'
import StopTitleToast from 'aria-viewer/stopselector/components/StopTitleToast'
import { PaymentsModuleContainer } from 'aria-viewer/payments'
import InquiryFormModal from 'aria-viewer/common/components/InquiryFormModal'
import {
    TOUR_DRAWER,
    VR_INSTRUCTION_DRAWER,
    showVRInstructionDrawer,
    hideDrawer,
} from 'aria-viewer/drawer/drawerMenuActions'
import { setActionButtons } from '../tourActions'
import DrawerFader from 'aria-viewer/drawer/drawerFader'
import VRInstructionsPanel from './panel/vrInstructionsPanel'
import StopDrawerFader from 'aria-viewer/stopselector/components/stopDrawerFader'
import ModalsContainer from 'aria-viewer/modal/components/modalsContainer'
import ModalIndex from 'aria-viewer/modal/components/index'
import MapFloatingContainer from 'aria-viewer/map/containers/mapFloatingContainer'
import BrowserNotSupported from 'aria-viewer/tour/components/browserNotSupported'
import OfflineExperience from 'aria-viewer/tour/containers/OfflineExperience'
import AutoPlay from '../components/autoplay'
import Browser from 'aria-viewer/utils/mobileDetect'
import { NextButton } from 'aria-viewer/navigation'
import withDeviceDimensions from 'aria-viewer/device/WithDeviceDimensions'
import InteractiveElementsListContainer from 'aria-viewer/interactive-element/containers/elements_list/InteractiveElementsList'
import { delay } from '../../utils/functions'
import AppVersionDisplay from 'aria-viewer/tour/containers/AppVersionDisplay'
import { Stats, FPSMeter } from 'aria-viewer/stats'
import IOSMotionOrientationPrompt from 'aria-viewer/tour/containers/IOSMotionOrientationPrompt'
import { setCountDown } from 'aria-viewer/audiomanager/countDownActions'
import { AUDIO_TOUR, stopAudio } from 'aria-viewer/audiomanager/audioManagerActions'
import { hideAvatar } from 'aria-viewer/guide/avatarActions'
import MediaViewer from '../containers/MediaViewer'
import IOSBadVersionBanner from 'aria-viewer/tour/containers/banners/IOSBadVersionBanner'
import TourProgressBanner from 'aria-viewer/tour/containers/banners/TourInProgressBanner'
import SupplementalMediaButton from 'aria-viewer/tour/containers/buttons/SupplementalMediaButton'

const S = {
    opacityHelper: {
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        background: 'transparent',
        zIndex: 8,
        transform: `translate3d(0, 0, 1px)`,
    },
    navigation: {
        position: 'absolute',
        bottom: '3.5em',
        left: '50%',
        transform: 'translateX(-50%)',
        WebkitBackfaceVisibility: 'hidden',
        zIndex: 5,
        height: '6.2em',
    },
    mainUILeftDrawer: {
        background: 'none',
    },
    mainUITopDrawer: {
        background: 'none',
        top: '0',
    },
    loadingScreen: {
        position: {
            textAlign: 'center',
        },
        loaderPosition: {
            height: '25vw',
        },
        image: {
            width: '20vw',
        },
        spinner: {
            width: '15vw',
            height: '15vw',
        },
    },
    mainContentWrapper: {
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
    },
    mainUIRight: {
        mediaPreview: {
            background: 'none',
            right: 0,
            left: null,
            zIndex: 8,
        },
        noMediaPreview: {
            background: 'none',
            right: 0,
            left: null,
            zIndex: 5,
        },
    },
    rightShadowDrawer: {
        background: 'none',
        left: null,
        right: 0,
        bottom: 0,
        boxShadow: 'rgba(0, 0, 0, 0.5) -15px 0 20px -6px inset',
    },
    drawerFaderInstructionPanel: {
        right: 0,
        left: null,
    },
    drawerFaderInstructionPanelOpaciyHelper: {
        transform: 'none',
    },
    tourDrawer: { backgroundColor: 'rgba(8, 19, 30, 0.9)', zIndex: 2005 },
    noPadding: {
        padding: '0',
    },
}

const styles = {
    interactiveElementsList: {
        position: 'absolute',
        bottom: ({ isMapEnabled }) => (isMapEnabled ? 250 : 80),
        zIndex: 900,
        left: 10,
        transition: 'left 0.25s ease-out, height 0.5s, width 0.5s, border-radius 0.2s ease-in 0.2s, bottom 0.5s ease',
        '&.expanded': {
            left: 0,
            bottom: 80,
            zIndex: 2000,
            transition: 'left 0.25s ease-out, height 0.5s, width 0.5s, bottom 0.5s ease',
        },
    },
    locationButton: {
        position: 'absolute',
        top: '0.95em',
        left: '1.5em',
        zIndex: 1999,
        fontWeight: 400,
        lineHeight: 1.55,
        textShadow: '0 0 3px rgba(0, 0, 0, 0.3)',
        animationName: 'fadeIn',
        animationFillMode: 'forwards',
        animationDuration: '0.3s',
    },

    nextButton: {
        position: 'absolute',
        top: '40%',
        right: 16,
        transform: 'translateY(-50%)',
        display: 'flex',
        width: 187,
        height: 170,
        zIndex: 100,
        userSelect: 'none',
        justifyContent: 'space-between',
        alignItems: 'center',
        animationName: 'fadeIn',
        animationFillMode: 'forwards',
        animationDuration: '0.3s',
    },
    '@keyframes fadeIn': {
        '0%': {
            opacity: 0,
        },
        '100%': {
            opacity: 1,
        },
    },
    offlineExperience: {
        position: 'absolute',
        zIndex: 3000,
    },

    avatarContainer: {
        right: 0,
        bottom: '5em',
        position: 'absolute',
        display: 'flex',
        alignItems: 'flex-end',
        width: '15.5em',
        zIndex: 5,
    },
}

const noop = _ => null

class AriaViewerDesktop extends PureComponent {
    static contextTypes = {
        width: PropTypes.number,
        height: PropTypes.number,
    }

    constructor(props) {
        super(props)

        this.elapsedTime = 10000
        this.state = {
            closeStopDrawFader: false,
            isTourloadedViaLinkChange: false,
            ready: false,
            leftReady: false,
            rightReady: false,
            topReady: false,
            drawerReady: false,
        }

        setTimeout(() => {
            props.setElapsedTime(this.elapsedTime)
        }, this.elapsedTime)
    }

    componentWillReceiveProps(nextProps, nextState) {
        /*
		This only gets called when it's a singleMedia tour
		 */
        const { mainMediaInitialized } = nextProps
        if (this.state.isTourloadedViaLinkChange) {
            this.setState({ isTourloadedViaLinkChange: false })
        }
        if (!this.props.mainMediaInitialized && mainMediaInitialized) {
            return this.setReady()
        }
    }

    componentDidMount() {
        this.props.mainMediaInitialized && this.setReady()
        //Enable countdown if we have audio, ie "isAudioButtonVisible", if autoplay not disabled, and if there's an audio url
        this.props.setCountDown(
            this.props.isAudioButtonVisible && this.props.autoplay && this.props.pointInfo.audio_url != ''
        )
    }

    setReady = async () => {
        await delay(1000).then(() => requestAnimationFrame(() => this.setState({ ready: true })))
        await delay(500).then(() => requestAnimationFrame(() => this.setState({ rightReady: true })))
        await delay(750).then(() => requestAnimationFrame(() => this.setState({ leftReady: true })))
        await delay(1000).then(() => requestAnimationFrame(() => this.setState({ drawerReady: true })))
        // await this.delay(1000).then(() => requestAnimationFrame(() => this.props.setActionButtons({visible: true})))
    }

    get sizes() {
        return {
            width: this.props.viewportWidth,
            height: this.props.viewportHeight,
        }
    }

    handleOnStopDrawerClose = params => {
        if (params && params.hasIntro) {
            //if intro present call the tourlistclose function
            this.handleOnTourListClose()
        }
    }

    handleOnTourListClose = () => {
        this.props.hideDrawer()
    }

    handleOnLinkChange = () => {
        this.setState({ isTourloadedViaLinkChange: true })
    }

    handleSupMediaPreviewVisible = () => {
        const { supplementalMediaPreviewVisible, showSupplementalMediaPreview } = this.props
        return supplementalMediaPreviewVisible ? showSupplementalMediaPreview(false) : null
    }

    getNavigation = () => {
        if (this.props.isWalkingtour || this.props.isHybridtour) {
            return <Navigation style={S.navigation} sizes={this.sizes} />
        }
    }

    getVRInstructionPanel = () => {
        return <VRInstructionsPanel />
    }

    toursList = () => {
        return (
            <ToursList
                title="Select an Experience"
                closeButton={true}
                width={540}
                height={300}
                onClose={this.handleOnTourListClose}
                onLinkChange={this.handleOnLinkChange}
            />
        )
    }

    getMainUITop = () => {
        return (
            <div>
                <LocationTitleButton className={this.props.classes.locationButton} />

                <TourButtons containerPosition={RIGHT_TOP} sizes={this.sizes} />

                <TourButtons containerPosition={TOP_RIGHT} sizes={this.sizes} />
            </div>
        )
    }

    getMainUILeft = () => {
        return (
            <div>
                <TourButtons containerPosition={BOTTOM_LEFT} sizes={this.sizes} />

                <MapFloatingContainer sizes={this.sizes} />

                {this.props.hasMultipleStops && <StopsList {...this.sizes} />}

                <InteractiveElementsListContainer className={this.props.classes.interactiveElementsList} />
            </div>
        )
    }

    getMainUIRight = () => {
        return (
            <div style={S.noPadding}>
                <TourButtons containerPosition={BOTTOM_RIGHT} sizes={this.sizes} />
            </div>
        )
    }

    getOverlay = () => {
        return (
            !Browser.mobile() && (
                <OpacityHelper
                    onClick={this.handleSupMediaPreviewVisible}
                    test={this.props.supplementalMediaPreviewVisible}
                    style={S.opacityHelper}
                >
                    {noop}
                </OpacityHelper>
            )
        )
    }

    getMainUI = () => {
        const { isSingleMedia, loading, supplementalMediaPreviewVisible } = this.props

        //dont include drawers if it's a single media
        return isSingleMedia ? (
            <div
                style={{
                    display: this.showMainUI && !loading ? 'block' : 'none',
                }}
            >
                {this.getMainUIRight()}
                {!this.props.loadSingleStopOnly && this.getMainUILeft()}
                {this.getMainUITop()}
            </div>
        ) : (
            // TODO: Factor out MainUI into separate mobile
            // and desktop components. Create individual pure
            // UI components like RightUIDrawer, LeftUIDrawer, etc.

            // Ideally should be an individual component
            <div>
                {this.getOverlay()}
                <div>
                    <Drawer
                        ignoreUnmount={true}
                        location="right"
                        open={this.showMainUI}
                        width={250}
                        style={
                            supplementalMediaPreviewVisible ? S.mainUIRight.mediaPreview : S.mainUIRight.noMediaPreview
                        }
                        height={1}
                        boxShadow={false}
                    >
                        {this.state.rightReady && this.getMainUIRight}
                    </Drawer>
                    {
                        // Separate Drawer for shadow
                    }
                    <Drawer
                        ignoreUnmount={true}
                        location="right"
                        open={this.showMainUI}
                        width={25}
                        style={S.rightShadowDrawer}
                        boxShadow={false}
                    >
                        {noop}
                    </Drawer>
                </div>
                <Drawer
                    ignoreUnmount={true}
                    location="left"
                    open={this.showMainUI || this.props.mapDisplayMode === MapDisplayModes.FULLSCREEN}
                    width={250}
                    style={S.mainUILeftDrawer}
                    boxShadow={false}
                >
                    {!this.props.loadSingleStopOnly && this.state.leftReady && this.getMainUILeft}
                </Drawer>

                <Drawer location="top" open={this.showMainUI} style={S.mainUITopDrawer} height={1} boxShadow={false}>
                    {this.getMainUITop}
                </Drawer>
            </div>
        )
    }

    /**
     * Determine which Registration to Render
     * CIF || Traditional Form
     */
    RegistrationProvider = () => {
        return this.props.isCIFForm || this.props.isAppilyForm ? (
            <InquiryFormModal hasBorder={true} />
        ) : (
            <RegistrationWrapper desktop={true} {...this.sizes} typeid={this.props.location.typeid} />
        )
    }

    render() {
        const {
            altMainMedia,
            hasMultipleStops,
            isVideoUIVisible,
            isPanoUIVisible,
            mainMediaInitialized,
            classes,
        } = this.props
        this.showMainUI =
            !altMainMedia &&
            mainMediaInitialized &&
            ((this.props.mainMedia.mediaType === 'video' && isVideoUIVisible) ||
                (this.props.mainMedia.mediaType === 'panorama' && isPanoUIVisible) ||
                this.props.mainMedia.mediaType === 'photo')
        // this.showMainUI = true;
        return (
            this.props.tourLoading && (
                <ContextMenuManager registry={ContextMenuIndex}>
                    <AppVersionDisplay />
                    <IOSBadVersionBanner />
                    <TourProgressBanner />
                    <Stats />
                    <FPSMeter />
                    <AutoPlay />
                    <MediaViewer />
                    <ModalsContainer desktop={true} registry={ModalIndex} />
                    <this.RegistrationProvider />
                    <div style={S.mainContentWrapper}>
                        <LoadingScreen class="gray" style={S.loadingScreen} typeid={this.props.location.typeid} />
                        <MainMediaManager positionalmedia={true} sizes={this.sizes} style={this.sizes} />
                        {!this.props.loadSingleStopOnly && this.getNavigation()}
                        {this.showMainUI && this.state.ready && this.getMainUI()}

                        <div className={classes.avatarContainer}>
                            <SupplementalMediaButton />
                            <Avatar {...this.sizes} />
                        </div>

                        {!this.props.loadSingleStopOnly && (
                            <Drawer name={TOUR_DRAWER} location="top" style={S.tourDrawer}>
                                {this.toursList}
                            </Drawer>
                        )}
                        {hasMultipleStops && !this.props.loadSingleStopOnly && this.state.drawerReady && (
                            <StopDrawerFader
                                {...this.sizes}
                                close={this.state.closeStopDrawFader}
                                onOpen={this.handleOnStopDrawerOpen}
                                onClose={this.handleOnStopDrawerClose}
                            />
                        )}
                        <DrawerFader
                            style={S.drawerFaderInstructionPanel}
                            name={VR_INSTRUCTION_DRAWER}
                            location="right"
                            width={400}
                            autoHide={false}
                            hideOnOverlayClick={true}
                            opacityHelperStyle={S.drawerFaderInstructionPanelOpaciyHelper}
                        >
                            {this.getVRInstructionPanel}
                        </DrawerFader>
                    </div>
                    <StopTitleToast sizes={this.sizes} />
                    {this.showMainUI && this.state.ready && hasMultipleStops && (
                        <NextButton className={classes.nextButton} />
                    )}
                    <BrowserNotSupported />
                    <OfflineExperience className={classes.offlineExperience} />
                    <PaymentsModuleContainer />
                    <IOSMotionOrientationPrompt />
                </ContextMenuManager>
            )
        )
    }
}

export default compose(
    connect(state => ({
        isCIFForm: state.getIn(['registration', 'formType']) == 'cif',
        isAppilyForm: state.getIn(['registration', 'formType']) == 'appily',
        autoplay: state.getIn(['audioManager', 'autoplay']),
    })),
    connect(
        mapSelectorsToProps([
            'isAudioButtonVisible',
            'mapDisplayMode',
            'isWalkingtour',
            'isHybridtour',
            'isMediatour',
            'isSingleMedia',
            'loadSingleStopOnly',
            'supplementalMediaPreviewVisible',
            'loading',
            'tourLoading',
            'mainMedia',
            'mainMediaInitialized',
            'altMainMedia',
            'isRegistrationEnabled',
            'hasMultipleStops',
            'isVideoUIVisible',
            'isPanoUIVisible',
            'viewportWidth',
            'viewportHeight',
            'isMapEnabled',
            'hasMultipleToursLocations',
            'location',
            'pointInfo',
        ]),
        {
            showVRInstructionDrawer,
            showSupplementalMediaPreview,
            hideDrawer,
            setActionButtons,
            setElapsedTime,
            setCountDown,
            stopAudio,
            hideAvatar,
        }
    ),
    withDeviceDimensions,
    injectJss(styles)
)(AriaViewerDesktop)
